<template>
  <DBox
    :id="'cmp-booking-booking_list-booking_sidewindow-invoicing'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('add_new_invoice_line')"
    :rightMenu="[
      {
        text: $t('create_invoice'),
        value: 'create_invoice',
        type: isEnabled ? '' : ' disabled',
      },
    ]"
    @menuClick="onRightMenuClick"
    @add_click="openAddInvoiceModal"
  >
    <!-- type: ' disabled' -->
    <!-- type: isEnabled ? ' disabled' : '' -->

    <!-- <div class="invoicing dbox"> -->
    <div class="invoicing" style="max-height: 512px; overflow-x: auto">
      <div class="dt-table3" style="min-width: 800px">
        <div class="dt-table3--row header" row wrap>
          <div class="dt-table3--column header">
            <!-- <div class="pad--510">Invoicing</div> -->
            <div class="pad--510">{{ $t("invoicing") }}</div>
          </div>
          <div class="dt-table3--column header">
            <!-- <div class="pad--510">Item</div> -->
            <div class="pad--510">{{ $t("item") }}</div>
          </div>
          <div class="dt-table3--column header">
            <!-- <div class="pad--510">Text</div> -->
            <div class="pad--510">{{ $t("text") }}</div>
          </div>
          <div class="dt-table3--column header">
            <!-- <div class="pad--510">Ammount/Currency</div> -->
            <div class="pad--510 text-right">{{ $t("amount") }}</div>
          </div>
          <div class="dt-table3--column header">
            <div class="pad--510">{{ $t("currency") }}</div>
          </div>
          <div class="dt-table3--column header">
            <!-- <div class="pad--510">Due</div> -->
            <div class="pad--510">{{ $t("due") }}</div>
          </div>
          <div class="dt-table3--column header" style="text-align: center">
            <!-- <div class="pad--510">Invoice</div> -->
            <div class="pad--510">{{ $t("invoice") }}</div>
          </div>
          <div class="dt-table3--column header">
            <!-- <div class="pad--510">Tax Type</div> -->
            <div class="pad--510">{{ $t("tax_type") }}</div>
          </div>
          <div class="dt-table3--column header"></div>
        </div>
        <div class="dt-table3--body">
          {{ minimizedGroups.length }}
          <template v-for="invoiceGroup of catagorizedInvoiceLines">
            <div
              class="dt-table3--row"
              :key="invoiceGroup.external_id2"
              v-if="invoiceGroup.external_id2 != booking.calendar_date_id"
            >
              <div class="dt-table3--column invoice-group-title">
                {{ invoiceGroup.title }}
              </div>
              <div class="dt-table3--column options">
                <div
                  class="dt-icon-container"
                  v-if="!minimizedGroups.has(invoiceGroup.external_id2)"
                >
                  <img
                    @click="(e) => minimizeInvoiceGroup(invoiceGroup)"
                    src="static/icons/minus.svg"
                    class="dt-icon v5 s1"
                    alt
                  />
                </div>
                <div class="dt-icon-container" v-else>
                  <img
                    @click="(e) => maximizeInvoiceGroup(invoiceGroup)"
                    src="static/icons/plus.svg"
                    class="dt-icon v5 s1"
                    alt
                  />
                </div>
              </div>
            </div>
            <div
              :key="invoiceGroup.external_id2 + '_lines'"
              class="invoice-group-lines"
              :class="{
                expanded: !minimizedGroups.has(invoiceGroup.external_id2),
              }"
            >
              <div
                class="dt-table3--row"
                v-for="invoiceLine of invoiceGroup.invoice_lines"
                :key="invoiceLine.invoiceline_id"
              >
                <div class="dt-table3--column">
                  <div class="txtov pad--510">
                    {{ invoiceLine.artist_name }}
                  </div>
                </div>
                <div class="dt-table3--column item">
                  <div class="txtov pad--510">{{ invoiceLine.item_name }}</div>
                </div>
                <div class="dt-table3--column">
                  <InputField2
                    v-if="invoiceLine['isEditable']"
                    :value="invoiceLine['text']"
                    class="v2"
                    @blur="(e) => onInvoiceLineTextBlur(e, invoiceLine)"
                  ></InputField2>
                  <div
                    v-else
                    class="invoice-text txtov pad--510"
                    type="text"
                    :title="invoiceLine['text']"
                  >
                    {{ invoiceLine["text"] }}
                  </div>
                </div>
                <div class="dt-table3--column calculator-icon">
                  <div class="amount-currency">
                    <div class="dt-icon-container">
                      <img
                        v-if="
                          invoiceLine.cost_center2 && !invoiceLine.invoice_id
                        "
                        src="static/icons/calculator.svg"
                        @click="(e) => onCalculateClick(invoiceLine)"
                        class="dt-icon v5 s1"
                        alt="Delete Status"
                        title=""
                      />
                    </div>

                    <div
                      class="amount"
                      :class="{
                        'calc-highlight':
                          isCalchighlight(invoiceLine['price']) &&
                          !invoiceLine['color'],
                      }"
                    >
                      <!-- <input
                        v-if="invoiceLine['isEditable']"
                        type="text"
                        class="dt-table3--textfield"
                        :name="'amount' + invoiceLine.invoiceline_id"
                        :id="'amount' + invoiceLine.invoiceline_id"
                        placeholder="Insert Price"
                        :value="invoiceLine['price']"
                        @blur="
                          e =>
                            onInvoiceLinePriceBlur(e.target.value, invoiceLine)
                        "
                        @click="onInvoiceLinePriceClick(invoiceLine)"
                      /> -->
                      <TextField2
                        class="input-text-right amount-price"
                        v-if="invoiceLine['isEditable']"
                        :name="'amount' + invoiceLine.invoiceline_id"
                        :id="'amount' + invoiceLine.invoiceline_id"
                        :showLabel="false"
                        :placeholder="$t('insert_price')"
                        :value="invoiceLine['price']"
                        type="number"
                        @blur="
                          ({ name, value }) =>
                            onInvoiceLinePriceBlur(value, invoiceLine)
                        "
                        @click="onInvoiceLinePriceClick(invoiceLine)"
                      />
                      <div
                        style="text-align: right"
                        class="amount-text pad--510"
                        v-else
                      >
                        {{ invoiceLine["price"] }}
                      </div>
                    </div>
                    <!-- <div class="currency" v-if="getCurrencyById(invoiceLine['invoice_currency_id'])">
                      {{getCurrencyById(invoiceLine['invoice_currency_id']).text}}
                    </div>-->
                  </div>
                </div>
                <div class="dt-table3--column">
                  <div class="currency">
                    <!-- <Dropdown
                      v-if="invoiceLine['isEditable']"
                      class="dbox-table--dropdown"
                      :options="booking.currenciesTV"
                      :selected="getCurrency(invoiceLine)"
                      :placeholder="'Currency'"
                      v-on:selectedChange="
                        e => onInvoiceLineCurrencySelected(e, invoiceLine)
                      "
                    ></Dropdown>
                    <span v-else class="currency--text">{{
                      getCurrency(invoiceLine).text
                    }}</span> -->

                    <!-- e.value ==
          (invoiceLine["invoice_currency_id"] ||
            this.booking.currency?.currency_id) -->

                    <!-- :selected="
                        booking.currenciesTV.find(
                          e => e.value == invoiceLine.currency_id
                        )
                      " -->
                    <Dropdown2
                      v-if="invoiceLine['isEditable']"
                      class="dbox1"
                      :showLabel="false"
                      :options="booking.currenciesTV"
                      :selected="getCurrency(invoiceLine)"
                      v-on:selectedChange="
                        (e) => onInvoiceLineCurrencySelected(e, invoiceLine)
                      "
                      :bb="'0px'"
                    />
                    <span v-else class="currency--text">{{
                      getCurrency(invoiceLine).text
                    }}</span>
                  </div>
                </div>

                <div class="dt-table3--column">
                  <DatePicker2
                    :disabled="invoiceLine['color'] ? true : false"
                    id="due_date"
                    :showLabel="false"
                    :value="invoiceLine['due_date']"
                    @input="
                      ({ name, value }) =>
                        onInvoiceLineDateUpdate(value, invoiceLine)
                    "
                    bb="none"
                  />
                  <!-- <div class="due-date">
                    <div class="date-value pad--510">
                      <template v-if="invoiceLine['due_date']">{{
                        invoiceLine["due_date"]
                      }}</template>
                    </div>

                    <v-menu
                      ref="menu"
                      class="date-menu"
                      :close-on-content-click="false"
                      v-model="datePickers[invoiceLine.invoiceline_id]"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <div class="date-icon" slot="activator">
                        <div class="dt-icon-container">
                          <img
                            src="static/icons/calendar.svg"
                            class="dt-icon v5 s1"
                            alt
                          />
                        </div>
                      </div>
                      <v-date-picker
                        :value="invoiceLine['due_date']"
                        @input="e => onInvoiceLineDateUpdate(e, invoiceLine)"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                      </v-date-picker>
                    </v-menu>
                  </div> -->
                </div>

                <div class="dt-table3--column invoice-ref-check">
                  <div class="invoice-ref" v-if="invoiceLine['invoice_ref']">
                    <div class="invoice-ref--text txtov pad--510">
                      <router-link
                        class="dt-button v3 ut-text-accent5"
                        :title="invoiceLine['invoice_ref']"
                        :to="{
                          name: invoiceListLDTRoutes.names.tab,
                          params: {
                            invoice_id: invoiceLine.invoice_id,
                            tab: 'overview',
                          },
                          query: {
                            from: encodeRoute($route),
                          },
                        }"
                        >{{ invoiceLine["invoice_ref"] }}</router-link
                      >
                    </div>
                    <div class="invoice-ref--email">
                      <div
                        @click="(e) => onMailButtonClick(invoiceLine)"
                        class="dt-icon-container"
                      >
                        <img
                          src="static/icons/email/email-grey.svg"
                          class="dt-icon v5 s1"
                          alt
                        />
                      </div>
                    </div>
                  </div>
                  <div v-else class="dt-checkbox invoice-checkbox v2 s1">
                    <input
                      type="checkbox"
                      :name="invoiceLine.invoiceline_id"
                      :id="invoiceLine.invoiceline_id"
                      :checked="
                        selectedInvoiceLines.has(invoiceLine['invoiceline_id'])
                      "
                      @click="(e) => onCheckboxChange(e, invoiceLine)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
                <div class="dt-table3--column">
                  <Dropdown2
                    v-if="invoiceLine['isEditable']"
                    class="dbox1"
                    :showLabel="false"
                    :options="booking.tax_typesTV"
                    :selected="
                      booking.tax_typesTV.find(
                        (e) => e.value == invoiceLine['tax_type_id']
                      )
                    "
                    v-on:selectedChange="
                      (e) => onInvoiceLineTaxTypeSelected(e, invoiceLine)
                    "
                    :bb="'0px'"
                  />

                  <div v-else class="pad--510">
                    <!-- {{ invoiceLine["tax_type_id"] }}

                    {{ booking.tax_typesTV }} -->

                    {{
                      booking.tax_typesTV.find(
                        (e) => e.value == invoiceLine["tax_type_id"]
                      ) &&
                      booking.tax_typesTV.find(
                        (e) => e.value == invoiceLine["tax_type_id"]
                      ).text
                    }}
                  </div>
                </div>
                <div class="dt-table3--column">
                  <div
                    v-if="invoiceLine['color']"
                    class="color"
                    :style="{
                      backgroundColor: getInvoiceStatColor(
                        invoiceLine['color']
                      ),
                      width: '15px',
                      height: '15px',
                      borderRadius: '15px',
                      margin: '8px auto 0',
                    }"
                  ></div>
                  <div v-else class="ut-rowcen">
                    <div class="dt-icon-container">
                      <img
                        @click="removeInvoiceLine(invoiceLine)"
                        src="static/icons/delete.svg"
                        class="dt-icon v5 s1 ut-center"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div
        class="item-groups-container"
        v-if="!invoice_lines || (invoice_lines && invoice_lines.length === 0)"
      >
        <div
          class="item-group ut-flex"
          v-for="item of booking.invoice_itemgroups"
          :key="item.group_name"
          @click="onItemGroupClicked(item)"
        >
          <div class="group-button">
            <button class="dt-button v5 s8">{{$t('new')}}</button>
          </div>
          <div class="group_name ut-text-accent5 ut-curpoint">
            {{ item.group_name }}
          </div>
        </div>
      </div>

      <!-- <div class="dbox-title-bar--options">
        <img
          @click="openAddInvoiceModal"
          src="static/icons/add-icon.svg"
          class="dt-icon v4"
          alt
        /> -->
      <!-- <div class="button add-button">
          <div class="dt-icon-container">
            <img @click="openAddInvoiceModal" src="static/icons/add.svg" class="dt-icon" alt="">
          </div>
      </div>-->
      <!-- </div> -->
    </div>
  </DBox>
</template>

<script>
import * as querystring from "querystring";
import InputField2 from "../../../../plugins/text-field/input-field2";
import {
  categorizeInvoiceLines,
  mailInvoice,
} from "../../models/invoice-lines.model";
import { addRemoveSet, encodeRoute, calcPercent } from "../../../../utility";
import { BookingService } from "../../services/booking-service";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { pipe, replace } from "ramda";
import { getInvoiceStatColor } from "../../../accounting/models/color-status";
import { showError } from "../../../../dt-plugins/notification/notification.service";

export default {
  components: {
    InputField2,
  },
  props: ["booking", "selectedInvoiceLines"],
  data: function () {
    return {
      minimizedGroups: new Set(),
      datePickers: {},
      calcHighlightFlag: false,

      invoiceListLDTRoutes: invoiceListLDTRoutes,
      encodeRoute: encodeRoute,

      calcTarget: null,
      calcSource: null,
    };
  },
  computed: {
    moneyDetailsInvoicesListHeaders: function () {
      return [
        {
          text: "",
          value: "artist_name",
          sortable: false,
          align: "left",
        },
        {
          text: "Item",
          value: "item_name",
          sortable: false,
          align: "left",
        },
        {
          text: "Text",
          value: "text",
          align: "left",
        },
        {
          text: "Amount/Currency",
          value: "price, ",
          align: "left",
        },
        {
          text: "Due",
          value: "due_date",
          align: "left",
        },
        {
          text: "Invoice",
          value: "invoice_item_id",
          align: "left",
        },
        {
          text: "Tax Type",
          value: "tax_type_id",
          align: "left",
        },
        {
          text: "",
          value: "close",
          align: "left",
        },
      ];
    },
    invoice_lines: function () {
      return this?.booking?.invoice_lines || [];
    },
    catagorizedInvoiceLines: function () {
      return categorizeInvoiceLines(
        this.invoice_lines,
        this.booking?.calendar_date_id
      );
    },

    isEnabled: function () {
      // console.log("Create invoice ", this.selectedInvoiceLines.size > 0);
      return this.selectedInvoiceLines.size > 0;
    },
  },
  methods: {
    getInvoiceStatColor: getInvoiceStatColor,
    onInvoiceLineTextBlur: function (e, item) {
      // this.$emit('invoice_text_updated', { value: e, invoiceLineId: item.invoiceline_id});

      console.log("Template Value", item);

      this.$emit("updated", {
        item,
        name: "text",
        value: templateInvoiceText(e, item),
      });
    },
    onInvoiceLineCurrencySelected: function (e, item) {
      console.log("Currency ... ", e, item);
      const selectedCurrency = this.booking.currencies.find(
        (element) => element["currency_id"] == e.value
      );
      const currency = this.booking.currency;

      if (!selectedCurrency || !currency) {
        console.log(
          "Selected Currency or Default Exchange Rate is not defined"
        );
        return;
      }

      let final_amount =
        (parseFloat(item.price) / parseFloat(selectedCurrency.exchange_rate)) *
        parseFloat(currency?.exchange_rate);
      final_amount = Math.round(final_amount * 100) / 100;
      const changeText = ` (${item.price} ${selectedCurrency.currency_iso} -> ${final_amount} ${currency.currency_iso})`;

      // console.log("Log: final_amount", final_amount);
      this.$emit("updated", {
        item,
        name: "pricetext",
        price: final_amount,
        text: item.text + changeText,
      });
    },
    onInvoiceLinePriceBlur: function (value, item) {
      this.$emit("updated", {
        item,
        name: "price",
        value: value,
      });
    },
    onItemGroupClicked: function (item) {
      this.$emit("inserted", {
        item,
      });
    },
    removeInvoiceLine: function (item) {
      this.$emit("deleted", { item });
    },
    minimizeInvoiceGroup: function (invoiceGroup) {
      this.minimizedGroups = addRemoveSet(
        true,
        this.minimizedGroups,
        invoiceGroup["external_id2"]
      );
      // console.log(this.minimizedGroups);
    },
    maximizeInvoiceGroup: function (invoiceGroup) {
      this.minimizedGroups = addRemoveSet(
        false,
        this.minimizedGroups,
        invoiceGroup["external_id2"]
      );
      // console.log(this.minimizedGroups);
    },
    onCheckboxChange: function (event, item) {
      const selectedLines = addRemoveSet(
        event.target.checked,
        this.selectedInvoiceLines,
        item["invoiceline_id"]
      );
      this.$emit("selected", {
        selectedLines,
      });
    },
    onInvoiceLineDateUpdate: function (value, item) {
      this.datePickers[item.invoiceline_id] = false;
      console.log(value);

      this.$emit("updated", {
        item,
        name: "due_date",
        value: value,
        text: templateInvoiceText(item.text, {
          ...item,
          due_date: value,
        }),
      });

      // this.$emit("updated", {
      //   item,
      //   name: "text",
      //   value: templateInvoiceText(item.text, {
      //     ...item,
      //     due_date: value,
      //   }),
      // });
    },
    onInvoiceLineTaxTypeSelected: function (event, item) {
      const taxType = this.booking.tax_types.find(
        (e) => e.tax_type_id == event.value
      );

      console.log(taxType);
      this.$emit("updated", {
        item,
        name: "tax_type_id",
        value: taxType.tax_type_id,
        value2: taxType.vat_type,
      });
    },
    openAddInvoiceModal: function () {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, modal: "add_invoice_line" },
      });
    },
    // openAddInvoiceModal: function() {
    //   this.$emit("add_click", true);
    // },
    onMailButtonClick: async function (invoiceLine) {
      mailInvoice(invoiceLine);
      /*
      // console.log(invoiceLine);
      const paypalMsg = await BookingService.findPaypalPaymentMsg({
        invoiceId: invoiceLine.invoice_id,
      });

      const emailDetails = await BookingService.findInvoiceEmailDetails({
        invoiceId: invoiceLine.invoice_id,
      });

      // console.log(paypalMsg, emailDetails);
      const email = emailDetails.data.email;
      const emailText = emailDetails.data.invoice_email_text;

      location.href = `mailto:?${querystring.stringify({
        subject: "Invoice Details",
        body: emailText,
      })}`;
      */
    },

    // Calculator Methods
    stopCalcHighlight: function () {
      this.resetCalcFlags();
    },
    onCalculateClick: function (item) {
      this.calcHighlightFlag = !this.calcHighlightFlag;

      if (this.calcHighlightFlag) {
        this.calcTarget = item;
      } else {
        this.resetCalcFlags();
      }
    },
    resetCalcFlags: function () {
      this.calcHighlightFlag = false;
      this.calcTarget = null;
      this.calcSource = null;
    },
    isCalchighlight: function (value) {
      return this.calcHighlightFlag && value && value.length > 0;
    },
    getCurrency: function (invoiceLine) {
      return this.booking?.currenciesTV?.find(
        (e) =>
          e.value ==
          (invoiceLine["invoice_currency_id"] ||
            this.booking.currency?.currency_id)
      );
    },

    onInvoiceLinePriceClick: function (item) {
      if (!this.calcHighlightFlag) {
        return;
      }
      if (!this.calcTarget && item.cost_center2) {
        this.calcTarget = item;
      } else if (!item.cost_center2) {
        this.calcSource = item;
        this.calcExecute();
      }
    },
    calcExecute: function () {
      // const addition =  (calcPercent(this.calcSource.price) (this.calcTarget.cost_center2));
      const addition = calcPercent(this.calcSource.price)(
        this.calcTarget.cost_center2
      );
      this.$emit("updated", {
        item: this.calcTarget,
        name: "price",
        value: (+this.calcTarget.price + addition).toFixed(2),
      });
      this.stopCalcHighlight();
    },

    onRightMenuClick: function (menu) {
      if (this.isEnabled) {
        this.$emit("menu_click", menu);
      }

      if (menu == "create_invoice") {
        // Check Selected Invoice Exists
        if (this.selectedInvoiceLines.size == 0) {
          showError("Please select what should be invoiced");
          return;
        }
        this.$router.push({
          ...this.$route,
          query: {
            ...this.$route.query,
            modal: "create_invoice",
          },
        });
      }
    },
    //MARK: Methods
  },
};

export const templateInvoiceText = (value, item) => {
  const transform = pipe(
    replace(new RegExp("#duedate#", "g"), item.due_date || "#duedate#")
  );

  return transform(value);
};
</script>

<style lang="scss" scoped>
.invoicing {
  &.LOADING {
    opacity: 0.5;
  }
}

.item-group {
  // margin: 5px 0px;
  padding: 4px 0;
  border-bottom: 1px solid var(--sprt-12);

  &:nth-child(even) {
    // background: var(--sprt-9);
  }

  .group_name {
    // padding: 10px;
  }
}

// New Table Styles 2019

// 1.1 1.4 1.8 1.1 1.1 1.2 0.9 0.3

// Newer Style 2021

// 1.5 1.1 2.1 1.2 0.7 1.1 1.2 0.7 0.3

.dt-table3 {
  position: relative;
  --header-align: left;
  // --header-row-padding: 5px 0px 5px 5px;
  // --header-col-padding: 0px 0px 5px 5px;
  --row-padding: 0px 0px 0px 0px;
  --col-padding: 0px;
  --row-height: 32px;

  .dt-table3--column {
    color: #828282;
    &:nth-child(1) {
      flex: 1.5;
    }
    &:nth-child(2) {
      flex: 1.1;
    }
    &:nth-child(3) {
      flex: 2.1;
    }
    &:nth-child(4) {
      flex: 1.2;
      &.calculator-icon {
        display: flex;
        justify-content: space-between;
        img {
          /* width: 15px;
          height: 15px; */
        }
      }
    }

    &:nth-child(5) {
      flex: 0.7;
    }
    &:nth-child(6) {
      flex: 1.1;
      .date-menu {
        height: calc(var(--row-height) - 3px);
        .menu__activator {
          height: 100% !important;
          .date-icon {
            height: 100%;
            .dt-icon-container {
              display: flex;
              justify-content: center;
            }
          }
        }
      }
    }
    &:nth-child(7) {
      // flex: 1.2;
      min-width: 133px;
      max-width: 133px;
    }
    &:nth-child(8) {
      min-width: 78px;
      max-width: 78px;
      .dropdown--main__icon {
        .dt-icon {
          margin-top: -8px;
        }
      }
    }
    &:nth-child(9) {
      min-width: 30px;
      max-width: 30px;
    }

    &:not(:nth-child(1)):not(.header) {
      color: var(--text-2);
    }
    &:nth-child(1):not(.invoice-group-title):not(.header),
    &:nth-child(2):not(.header) {
      // opacity: 0.6;
    }

    &:not(.header) {
      border-right: 1px solid var(--sprt-12);
    }
    &:last-child:not(.header) {
      border-right: none;
    }

    // &:nth-child(1):not(.header),
    // &:nth-child(2):not(.header),
    // &:nth-child(3):not(.header),
    // &:nth-child(4):not(.header),
    // &:nth-child(5):not(.header) {`
    //   border-right: 1px solid var(--sprt-11);
    // }

    // &:nth-child(2).header,
    // &:nth-child(3).header,
    // &:nth-child(4).header,
    // &:nth-child(5).header {
    //   border-right: 1px solid transparent;
    // }

    // &:nth-child(6):not(.header),
    // &:nth-child(7):not(.header) {
    //   border-right: 1px solid var(--sprt-7);
    // }

    // &:nth-child(6).header,
    // &:nth-child(7).header {
    //   border-right: 1px solid transparent;
    // }

    &:nth-child(3):not(.header) {
      .dt-textfield--input {
        // padding-left: 5px;
      }
    }

    .calc-highlight {
      border: 1px solid blue;
    }

    &:nth-child(4):not(.header) {
      // padding-bottom: 0px;
      // padding: 0px;
      // padding-top: 0px;

      .amount-currency {
        padding: 0 2px 0 4px;
        .dt-textfield--input {
          padding-left: 5px;
        }
      }
    }

    .amount-currency {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .amount {
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        .amount-text {
          padding: 0px;
        }

        .amount-price {
          border-bottom: none !important;
        }

        input {
          &.fc-control {
            max-width: 80px;
            height: 21px;
            margin: 0;
            padding: 0 5px !important;
          }
        }
      }
    }
    .currency {
      flex: 0.8;
      .currency--text {
        display: block;
        padding: 5px 11px;
      }
    }
    .invoice-text {
      display: block;
      padding-top: 5px;
      padding-right: 5px;
    }
    &.invoice-ref-check {
      text-align: center;
      display: flex;
      justify-content: center;
    }
    .color {
      border: 1px solid var(--sprt-5);
      margin: 2px 2px 2px -2px;
    }
    .invoice-checkbox {
      margin-top: 8px;
    }
    .invoice-ref {
      width: 100%;
      display: flex;
      justify-content: center;

      &--text {
        flex: 1;
        a {
          font-weight: 400 !important;
        }
      }
      &--email {
        flex: 0.5;
        max-width: 30px;
      }
    }
  }

  .dt-table3--column.options {
    flex: 0.22;
    padding-left: 0px;
    min-width: 30px;
  }
  .dt-table3--column.invoice-group-title {
    flex: 8.9;
    color: var(--text-2); // expand
    font-weight: 500;
    padding: 5px 0 0 10px;
    border-right: 1px solid var(--sprt-7);
  }
}

.due-date {
  display: flex;
  .date-value {
    flex: 1.7;
  }
  .date-menu {
    min-width: 30px;
  }
}

.invoice-group-lines {
  max-height: 0px;
  overflow: hidden;
  transition: 200ms ease-out;
  &.expanded {
    max-height: 1000px;
  }
}
</style>

<style lang="scss">
.cmp-booking-booking_list-booking_sidewindow-invoicing {
  > div {
    &:first-child {
      > div {
        &:last-child {
          padding-right: 108px;
          // padding-right: 125px;
          > div {
            &:last-child {
              width: 133px;
              .dt-button {
                margin: 8px auto !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
